// Libarary Class
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subscription } from 'rxjs';
const _ = require('lodash');

// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { PgsOrderService } from './../../../../services/seed/pgs-order.service';
// Class
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { CommonService } from '../../../../services/common/common.service';
import { ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-proving-ground-seed-order-create',
  templateUrl: './proving-ground-seed-order-create.component.html',
  styleUrl: './proving-ground-seed-order-create.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ProvingGroundSeedOrderCreateComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  plotSeedLeadDate = 0;
  dashboardFilter: DashboardFilter;
  deliverToData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  pgsOrder: PgsOrder;
  salesManagerAccounts: any;
  shipToData: any;
  isProductExist = false;
  productLineData: any;
  productLineDateSetupList: any;
  displayedColumns: string[] = ['packName', 'allocatedQuantity', 'availableQuantity', 'orderQuantity'];
  selectedDealer: any;
  selectedSalesManager: any;
  deliverTo: any;
  isNotValid: any;
  isPlaceOrderDisable = true;
  productSearchFilter: any;
  productFilters: any;
  marketingMasterList: any = [];
  filterValueList: any = [];
  shipToDataLoading = true;
  locationDataLoading = true;
  pgsOrderSource: MatTableDataSource<any>;
  errorsList: Array<string> = [];
  error = false;
  pgsOrderSourceCopy: any;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  nextErrorId = 0;
  isEditMode = false;
  IsLinesGreaterThanZeroDisable = true;
  datemodel: NgbDateStruct;
  dateFilter: any;
  hasChangeAdded = false;
  userMenuAccessList: any;
  maxDate: Date = new Date();
  minDate: Date = new Date();
  defaultRequestDate: Date = new Date();
  readOnlyAccess = false;
  editFullAccess = false;
  isUserSalesManager = false;
  soldOutItemMsg: string = '';
  // Search Type set Up for grid
  searchTypeList: any[] = [
    { name: 'Pack Name', value: 'PackName' },
    { name: 'Hybrid Variety', value: 'Variety' },
    { name: 'Item Number', value: 'ItemNumber' }
  ];
  allocatedQuantity: number = 0;
  avilableQuantity: number = 0;
  totalOrderQuantity: number = 0;
  enableSearchButton = false;
  originalItemList: any;
  uniqueItemList: { itemId: number, itemNumber: string }[] = [];
  disableDeliverTo = false;
  isOrderEditable: boolean = false;
  orderHeaderId: number = 0;
  fromNewOrder: boolean = true;
  shipToAccountList: any;
  salesManagerAccountList: any;
  selectionDrivenBy: 'shipTo' | 'salesManager' | null = null;
  showPackModal = false;
  selectedPackName = '';
  selectedPackDetails: any[] = [];
  packDisplayedColumns: string[] = ['itemNumber', 'hybridVariety', 'quantity', 'uom'];
  lastUpdatedTime: any;
  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private pgsOrderService: PgsOrderService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef) {
    this.dashboardFilter = new DashboardFilter();
    this.pgsOrder = new PgsOrder();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    this.setAndValidateDefaultData();
    this.bindDataSource([], true);
    this.resetProductFilter();
    //this.getOrderDetails();
  }

  setAndValidateDefaultData() {
    this.subscription.push(this.pgsOrderService.pgsOrderHeaderId.subscribe(headerId => {
      if (headerId && headerId != 0) {
        this.orderHeaderId = headerId;
        this.fromNewOrder = false;
      }
      else {
        this.orderHeaderId = 0;
      }

      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (data !== null && data !== undefined && data.resultData.length > 0) {
          this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
          if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PROVING_GROUND_SEED_ORDER)) {
            this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PROVING_GROUND_SEED_ORDER, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
            this.editFullAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PROVING_GROUND_SEED_ORDER, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
            this.subscription.push(
              this.pgsOrderService.checkCreateAccess().subscribe((response) => {
                if (!this.orderHeaderId || this.orderHeaderId == 0) {
                  this.editFullAccess = response && this.editFullAccess ? true : false;
                }
                if (!this.editFullAccess && (!this.orderHeaderId || this.orderHeaderId == 0)) {
                  this.router.navigate(['/cc/landing-data']);
                }
                this.getPgsOrderInitialData();
              })
            );

          } else {
            this.router.navigate(['/cc/landing-data']);
          }
          //const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
          //if (isActiveUser.plotSeedLeadDay) {
          //  this.plotSeedLeadDate = isActiveUser.plotSeedLeadDay;

          //  this.setDefaultRequestDate();
          //}
        }
      }
      // Set the default value
      if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
        this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
      }
      this.errorMsgs = new Array();
    }));
  }

  // Get Plot Seed Initial Data
  getPgsOrderInitialData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.pgsOrderService.getCreateOrderHeaderData().subscribe((result: any) => {
      if (result) {
        this.isUserSalesManager = result.isUserSalesManager;
        this.shipToAccountList = result.shipToAccountList || [];
        this.salesManagerAccountList = result.salesManagerList || [];
        this.salesManagerAccounts = [...this.salesManagerAccountList];
        
        this.clearDetailGrid();
        if (this.isUserSalesManager) {
          const salesManager = this.salesManagerAccounts && this.salesManagerAccounts.length > 0
            ? this.salesManagerAccounts[0]
            : null;

          if (salesManager) {
            this.pgsOrder.SalesManagerAccount = salesManager.accountNumber;
            this.salesManagerAccounts = [salesManager];
            this.shipToData = this.filterShipToBySalesManager(+salesManager.accountNumber);
            if (!this.shipToData || this.shipToData.length === 0) {
              this.shipToData = [];
              this.toastrService.error('No eligible Ship-To Accounts are available for the selected Sales Manager.');
            }
            
            this.selectionDrivenBy = 'salesManager';
          }
        }
        else {
          this.shipToData = [...this.shipToAccountList];
        }
        this.shipToDataLoading = false;
        this.locationDataLoading = false;
        this.productLineData = result.productLineList;
        //this.productLineDateSetupList = result.productLineDateSetupList;
      } else {
        this.shipToDataLoading = false;
        this.locationDataLoading = false;
      }
      this.loaderService.setLoaderStatus(false);
      if (this.orderHeaderId > 0) {
        this.loadOrderDetails();
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
      this.locationDataLoading = false;
    }));
  }

  loadOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.enableSearchButton = true;
    this.subscription.push(this.pgsOrderService.getPgsEditOrderDetail(this.orderHeaderId).subscribe((result: any) => {
      if (result) {
        this.displayedColumns = ['packName', 'allocatedQuantity', 'availableQuantity', 'orderQuantity', 'status'];

        this.pgsOrder.OrderNumber = result.webOrderNumber;
        this.lastUpdatedTime = result.lastUpdatedTime;
        //make primary header readonly
        this.fromNewOrder = false;

        if (!this.fromNewOrder) {
          // Sales Manager
          const salesManagerDetails = {
            accountNumber: result.salesManagerAccountNumber,
            accountName: result.salesManagerAccountName,
            accountNameCityState: result.salesManagerAccountNumber +' - '+ result.salesManagerAccountName
          };

          this.salesManagerAccounts = [salesManagerDetails];

          this.pgsOrder.SalesManagerAccount = result.salesManagerAccountNumber;

          // Ship To Account
          const accountDetails = {
            accountNumber: result.shipToAccount,
            address1: result.shipToAddress1,
            city: result.shipToCity,
            state: result.shipToState,
            zipCode: result.zipCode,
            accountNameCityState: result.accountName
          };

          this.shipToData = [accountDetails];
          this.selectedDealer = accountDetails;
          this.pgsOrder.ShipToAccount = result.shipToAccount;

          // Product Line
          const productLineDetails = {
            id: result.productLineId || result.productLine,
            value: result.productLine
          };

          this.productLineData = [productLineDetails];
          this.pgsOrder.ProductLine = result.productLineId || result.productLine;
        }

        if (result.deliverToAccount) {
          // Create the object
          const deliverToDetails = {
            accountNumber: result.deliverToAccount,
            accountName: result.deliverToName,
            address1: result.deliverToAddress1,
            city: result.deliverToCity,
            state: result.deliverToState,
            zipCode: result.deliverToZipCode
          };
          this.deliverTo = deliverToDetails;
        }

        this.deliverToData = result.deliverTo || (result.deliverToAccount ? [this.deliverTo] : []);

        this.pgsOrder.DeliverToAccount = result.deliverToAccount;
        this.pgsOrder.DeliverToAnotherLocation = result.deliverToAccount > 0 ? true : false;
        this.pgsOrder.DeliveryInstructionsCodes = result.deliverInstructions;
        this.pgsOrder.IsCustomerPickup = result.customerPickup;

        this.pgsOrder.CustomerPO = result.customerPO;
        let rowId: Number = 0;
        const existingLines = (result.detailsData || []).filter(x => (x.status || '').toString().trim() !== '');
        const allLinesReleased = existingLines.length > 0 && existingLines.every(x => x.status.toString().trim().toUpperCase() === 'RELEASED');
        this.isOrderEditable = !!this.editFullAccess && !allLinesReleased;
        if (this.isOrderEditable) {
          this.minDate = this.defaultRequestDate;
          this.originalItemList = [...result.detailsData];
          this.readOnlyAccess = false;
          this.IsLinesGreaterThanZeroDisable = false;
          this.totalOrderQuantity = this.originalItemList.reduce((sum, x) => sum + (+x.orderQuantity || 0), 0);

        } else {
          this.originalItemList = existingLines;
          this.readOnlyAccess = true;
          this.IsLinesGreaterThanZeroDisable = true;
        }

        this.uniqueItemList = [];
        this.originalItemList.forEach(product => {
          rowId = +rowId + 1;
          product.rowId = +rowId;
          product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
          if (product.active === undefined || product.active === null) {
            product.active = !(+product.availableQuantity <= 0);
          }
          (product.packConfigDetails || []).forEach(d => {
            if (!this.uniqueItemList.some(x => x.itemId === d.itemId)) {
              this.uniqueItemList.push({ itemId: d.itemId, itemNumber: d.itemNumber });
            }
          });
        });
        this.pgsOrder.IsLinesGreaterThanZero = false;
        this.bindDataSource(this.originalItemList, true, true);

      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  isDisabled(isSalesManager: boolean): boolean {
    if (isSalesManager && this.isUserSalesManager) {
      return true;
    }

    if (this.fromNewOrder) {
      return false;
    }

    return this.readOnlyAccess || this.isOrderEditable;
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setSeedEditPageHeight();
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  resetEditFields(isShipTo = false) {
    if (this.orderHeaderId > 0) {
      this.orderHeaderId = 0;
      this.isOrderEditable = false;
      if (this.pgsOrder.DeliverToAccount) {
        this.pgsOrder.DeliverToAccount = null;
        this.deliverTo = null;
        this.pgsOrder.DeliverToAnotherLocation = false;
      }

      this.pgsOrder.CustomerPO = null;
      this.pgsOrder.DeliveryInstructionsCodes = null;
      this.pgsOrder.IsCustomerPickup = false;
      this.pgsOrder.IsLinesGreaterThanZero = false;
      this.readOnlyAccess = false;
      if (isShipTo) {
        this.originalItemList = null;
        this.enableSearchButton = false;
        this.clearDetailGrid();
      }
      this.enableDisablePlaceOrder();
    }
  }

  clearDetailGrid() {
    //this.originalItemList = [];
    this.totalOrderQuantity = 0;
    this.IsLinesGreaterThanZeroDisable = true;
    this.isPlaceOrderDisable = true;
    this.uniqueItemList = [];
    this.pgsOrder.IsLinesGreaterThanZero = false;
    this.productSearchFilter = this.searchTypeList[0].value;
    this.bindDataSource([], true);
    this.clearAllFilter();
    this.revertAllChanges();
  }
  // Get product list based on account selected
  getProductsList() {
    if (this.pgsOrder.ShipToAccount && this.pgsOrder.ProductLine) {
      this.loaderService.setLoaderStatus(true);
      this.clearDetailGrid();
      this.displayedColumns = ['packName', 'allocatedQuantity', 'availableQuantity', 'orderQuantity'];

      const filter = {
        SalesManagerAccountNumber: this.pgsOrder.SalesManagerAccount,
        ProductLineId: this.pgsOrder.ProductLine,
        HybridVarietyFilter: '',
        PackName: '',
        ItemNumber: ''
      };
      let rowId: Number = 0;
      this.subscription.push(this.pgsOrderService.getOrderDetailsData(filter).subscribe((result: any[]) => {
        const rows = result;
        if (rows.length > 0) {
          this.originalItemList = rows;
          this.totalOrderQuantity = 0;
          this.errorMsgs = new Array();
          this.uniqueItemList = [];
          this.originalItemList.forEach(product => {
            rowId = +rowId + 1;
            product.rowId = +rowId;
            product.orderQuantity = 0;
            product.active = !(+product.availableQuantity <= 0);
            product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
            product['lastUpdatedTime'];
            (product.packConfigDetails || []).forEach(d => {
              if (!this.uniqueItemList.some(x => x.itemId === d.itemId)) {
                this.uniqueItemList.push({ itemId: d.itemId, itemNumber: d.itemNumber });
              }
            });
          });



          this.enableSearchButton = true;
          this.bindDataSource(this.originalItemList, true);
        } else {
          this.totalOrderQuantity = 0;
          this.isPlaceOrderDisable = true;
          this.bindDataSource([], true);
          this.toastrService.error('No Proving Ground Seed pack allocations are available for the selected Sales Manager and Product Line.');
        }

        this.loaderService.setLoaderStatus(false);
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
      })));

    } else {
      this.bindDataSource([], true);
      this.loaderService.setLoaderStatus(false);
    }
  }

  // Combined filter application (for Search button)
  applyAllFilters(isCheckBox = false) {
    let filteredItems = [...this.originalItemList];

    // Pack Name filter (partial match)
    if (this.productFilters.PackName && this.productFilters.PackName.trim()) {
      const packTerm = this.productFilters.PackName.replace(/\s+/g, ' ').trim().toLowerCase();
      filteredItems = filteredItems.filter(item => String(item.packName || '').toLowerCase().includes(packTerm));
    }

    // Hybrid Variety filter (partial match on any item in the pack)
    if (this.productFilters.Variety && this.productFilters.Variety.trim()) {
      const searchTerm = this.productFilters.Variety.replace(/\s+/g, ' ').trim().toLowerCase();

      filteredItems = filteredItems.filter(item =>
        (item.packConfigDetails || []).some(d => String(d.hybridVariety || '').toLowerCase().includes(searchTerm)));
    }

    // Item Number filter (exact match on any item in the pack)
    if (this.productFilters.ItemNumberList && this.productFilters.ItemNumberList.length > 0) {
      const selectedItems = this.productFilters.ItemNumberList.map(x => String(x).toLowerCase());
      filteredItems = filteredItems.filter(item =>
        (item.packConfigDetails || []).some(d => selectedItems.includes(String(d.itemNumber || '').toLowerCase())));
    }

    if (!isCheckBox && filteredItems.length === 0) {
      this.toastrService.info('No matching packs found.');
    }

    this.bindDataSource(filteredItems, false);
  }
  // Search button click handler
  onSearchClick() {
    this.keepFilter();

    // Apply all filters
    this.applyAllFilters();
  }

  getOrderList() {
    const orderItems = this.originalItemList.filter(x => ((x.pgsOrderDetailId || 0) > 0 && x.active == true) || ((x.pgsOrderDetailId || 0) == 0 && x.orderQuantity > 0)).map(product => ({
      orderHeaderId: this.orderHeaderId,
      orderDetailId: product.pgsOrderDetailId || 0,
      pgsPackConfigHeaderId: product.pgsPackConfigHeaderId,
      packName: product.packName,
      orderQuantity: product.orderQuantity,
      lastUpdatedTime: product.lastUpdatedTime,
      availableQuantity: product.availableQuantity,
      allocatedQuantity: product.allocatedQuantity
    }));
    const {
      SalesManagerAccount,
      ProductLine,
      ShipToAccount,
      DeliverToAnotherLocation,
      DeliverToAccount,
      DeliveryInstructionsCodes,
      CustomerPO,
      IsCustomerPickup
    } = this.pgsOrder;

    const header = {
      orderHeaderId: this.orderHeaderId,
      webOrderNumber: this.pgsOrder.OrderNumber,
      salesManagerAccount: SalesManagerAccount,
      productLine: ProductLine,
      shipToAccount: ShipToAccount,
      deliveredToAccount: DeliverToAnotherLocation && DeliverToAccount ? DeliverToAccount : null,
      deliveryInstruction: DeliveryInstructionsCodes?.trim(),
      custPonumber: CustomerPO?.trim() || null,
      customerPickup: !!IsCustomerPickup,
      lastUpdatedTime: this.orderHeaderId > 0 ? this.lastUpdatedTime : null,
      fromEditConfirmationPage: this.isOrderEditable,
      orderDetailsData: orderItems
    };

    return header;
  }

  enableDisablePlaceOrder() {
    const deliverToRequired = this.pgsOrder.DeliverToAnotherLocation && this.deliverToData && this.deliverToData.length > 0 && !this.pgsOrder.DeliverToAccount;
    const hasNoErrors = !this.errorMsgs || this.errorMsgs.length === 0;
    if (!deliverToRequired && hasNoErrors && this.pgsOrderSource && this.pgsOrderSource.data && this.pgsOrderSource.data.length > 0 && (this.isOrderEditable || (this.totalOrderQuantity > 0 && this.pgsOrder.ProductLine && this.pgsOrder.ShipToAccount && this.pgsOrder.SalesManagerAccount))) {
      this.isPlaceOrderDisable = false;
    }
    else {
      this.isPlaceOrderDisable = true;
    }
  }

  getSalesManager($event) {
    this.selectedSalesManager = $event;
    this.originalItemList = null;
    this.clearDetailGrid();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { salesManagerUpdate: true });

    if ($event && $event.accountNumber) {
      if (this.selectionDrivenBy == null) {
        this.selectionDrivenBy = 'salesManager';
      }
      if (this.selectionDrivenBy == 'salesManager') {
        this.pgsOrder.ShipToAccount = null;
        this.selectedDealer = null;
        this.deliverToData = [];
        this.pgsOrder.DeliverToAccount = null;
        this.deliverTo = null;
        this.pgsOrder.DeliverToAnotherLocation = false;
        this.disableDeliverTo = true;
        this.getShipToAccounts($event.accountNumber);
      }
    } else {
      if (this.selectionDrivenBy == 'salesManager') {
        this.pgsOrder.ShipToAccount = null;
        this.selectedDealer = null;
        this.deliverToData = [];
        this.pgsOrder.DeliverToAccount = null;
        this.deliverTo = null;
        this.pgsOrder.DeliverToAnotherLocation = false;
        this.selectionDrivenBy = null;
        this.disableDeliverTo = true;
        this.resetMasterDropdownData();
      }

      this.resetEditFields();
      if (this.pgsOrderSource && this.pgsOrderSource.data && this.pgsOrderSource.data.length > 0) {
        this.pgsOrderSource = null;
        this.pgsOrderSourceCopy = null;
        this.bindDataSource([], false);
      }
      this.enableSearchButton = false;
    }
    this.pgsOrder.ProductLine = null;
    this.pgsOrder.CustomerPO = null;
    this.pgsOrder.DeliveryInstructionsCodes = null;
    this.pgsOrder.IsCustomerPickup = false;
  }

  getShipTo($event) {
    this.selectedDealer = $event;
    this.deliverToData = [];
    this.pgsOrder.DeliverToAccount = null;
    this.deliverTo = null;
    this.pgsOrder.DeliverToAnotherLocation = false;
    this.originalItemList = null;
    this.enableSearchButton = false;
    this.disableDeliverTo = true;
    this.clearDetailGrid();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { shiptoupdated: true });

    if ($event && $event.accountNumber) {
      if (!this.isUserSalesManager && this.selectionDrivenBy == null) {
        this.selectionDrivenBy = 'shipTo';
      }
      if (this.selectionDrivenBy == 'shipTo') {
        this.applySalesManagerFromShipTo($event);
      }
      this.getDeliverToAccounts($event);
      this.disableDeliverTo = false;
    } else {   
      if (this.selectionDrivenBy == 'shipTo') {
        this.selectionDrivenBy = null;
        this.resetMasterDropdownData();
        this.pgsOrder.SalesManagerAccount = this.isUserSalesManager && this.salesManagerAccounts && this.salesManagerAccounts.length > 0
          ? this.salesManagerAccounts[0].accountNumber
          : null;
      }    
      
      this.resetEditFields(true);
      
    }
    this.pgsOrder.ProductLine = null;
    this.pgsOrder.CustomerPO = null;
    this.pgsOrder.DeliveryInstructionsCodes = null;
    this.pgsOrder.IsCustomerPickup = false;
    this.enableDisablePlaceOrder();
  }

  getDeliverToAccounts($event) {
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
    if ($event && $event.accountNumber && $event.parentNumber) {
      this.getDeliverToAccountsListBasedOnShipto($event.accountNumber, $event.parentNumber);
    }
  }

  getProductLineChange() {
    this.originalItemList = null;
    this.enableSearchButton = false;
    this.clearDetailGrid();
    this.checkExistingOrder();
  }


  getShipToAccounts(accountNumber) {
    this.shipToData = this.filterShipToBySalesManager(accountNumber);
    if (!this.shipToData || this.shipToData.length === 0) {
      this.shipToData = [];
      this.toastrService.error('No eligible Ship-To Accounts are available for the selected Sales Manager.');
    }
    this.checkExistingOrder();
  }

  private resetMasterDropdownData() {
    if (!this.isUserSalesManager) {
      this.salesManagerAccounts = this.salesManagerAccountList ? [...this.salesManagerAccountList] : [];
    }
    this.shipToData = this.shipToAccountList ? [...this.shipToAccountList] : [];
  }

  private filterShipToBySalesManager(accountNumber: number) {
    if (!this.shipToAccountList || this.shipToAccountList.length === 0) {
      return [];
    }

    return this.shipToAccountList.filter(x => {
      const salesManagerIds = this.getSalesManagerIdsFromShipTo(x);
      return salesManagerIds.indexOf(+accountNumber) > -1;
    });
  }

  private applySalesManagerFromShipTo(shipToAccount: any) {
    if (!shipToAccount) {
      this.salesManagerAccounts = [];
      this.pgsOrder.SalesManagerAccount = null;
      return;
    }

    const salesManagerIds = this.getSalesManagerIdsFromShipTo(shipToAccount);
    if (!salesManagerIds || salesManagerIds.length === 0) {
      this.salesManagerAccounts = [];
      this.pgsOrder.SalesManagerAccount = null;
      this.toastrService.error('No eligible Sales Managers are available for the selected Ship-To Account.');
      return;
    }

    const matchedSalesManagers = (this.salesManagerAccountList || [])
      .filter(x => salesManagerIds.indexOf(+x.accountNumber) > -1);

    if (matchedSalesManagers && matchedSalesManagers.length > 0) {
      this.salesManagerAccounts = matchedSalesManagers;
      this.pgsOrder.SalesManagerAccount = matchedSalesManagers.length === 1
        ? matchedSalesManagers[0].accountNumber
        : null;
    } else {
      this.salesManagerAccounts = [];
      this.pgsOrder.SalesManagerAccount = null;
      this.toastrService.error('No eligible Sales Managers are available for the selected Ship-To Account.');
    }
  }

  private getSalesManagerIdsFromShipTo(shipToAccount: any): number[] {
    if (!shipToAccount) {
      return [];
    }

    if (Array.isArray(shipToAccount.data) && shipToAccount.data.length > 0) {
      return shipToAccount.data
        .map(x => +x)
        .filter(x => !isNaN(x));
    }

    if (shipToAccount.isAccountNumber) {
      const accountNumber = +shipToAccount.isAccountNumber;
      return isNaN(accountNumber) ? [] : [accountNumber];
    }

    return [];
  }

  getDeliverToAccountsListBasedOnShipto(accountNumber, parentAccountNumber) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.pgsOrderService.getDeliverTo(accountNumber, parentAccountNumber).subscribe(result => {
      if (result && result.length > 0) {
        this.deliverToData = result;
      }
      this.checkExistingOrder(true);
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  removeDeliverTo() {
    this.pgsOrder.DeliverToAccount = null;
    this.deliverTo = null;
    this.enableDisablePlaceOrder();
  }
  // Deliver to change event add the object to show the deliver to address
  getDeliverToAccount($event) {
    this.deliverTo = $event;
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
    this.enableDisablePlaceOrder();
  }

  checkExistingOrder(isShipTo = false) {
    if (this.pgsOrder.SalesManagerAccount && this.pgsOrder.ProductLine && this.pgsOrder.ShipToAccount) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.pgsOrderService.checkExistingOrder(this.pgsOrder.SalesManagerAccount, this.pgsOrder.ShipToAccount, this.pgsOrder.ProductLine).subscribe((headerId: number) => {
        this.loaderService.setLoaderStatus(false);
        if (headerId && headerId > 0) {
          this.orderHeaderId = headerId;
          this.isPlaceOrderDisable = true;
          this.loadOrderDetails();
        }
        else {
          this.resetEditFields(isShipTo);
          this.displayedColumns = ['packName', 'allocatedQuantity', 'availableQuantity', 'orderQuantity'];
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
    else {
      this.resetEditFields(isShipTo);
    }
  }

  // Place Plot Seed Order
  placeOrder() {
    let pgsOrderData = this.getOrderList();
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.pgsOrderService.placeOrder(pgsOrderData).subscribe((result: any) => {
      if (result && result.isConcurrencyConflict) {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('This order was changed by another user. The page has been refreshed with the latest data; please review and try again.');
        this.errorMsgs = new Array();
        this.showErrorBlock = false;
        this.loadOrderDetails();
        return;
      }
      const hasLineErrors = (result?.orderDetailsData || []).some(r => (r.errors || []).length > 0);
      if (result && result.orderHeaderId && !hasLineErrors) {
        if (this.isOrderEditable) {
          this.toastrService.success(`Proving Ground Seed Order ${result.webOrderNumber} Successfully Updated`);
        }
        else {
          this.toastrService.success(`Proving Ground Seed Order ${result.webOrderNumber} Successfully Saved`);
        }

        this.loaderService.setLoaderStatus(false);
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
          updateButtonClick: true
        });

        this.navigateToLanding();

        //this.pgsOrderService.setConfirmationPlotSeedOrderId(+result.orderHeaderId);
        //this.pgsOrderService.setRedirectionFrom(this.isOrderEditable ? 'Update' :'Add');
        //this.router.navigate(['/plot-seed/plot-seed-summary']);
      } else {
        this.errorMsgs = new Array();
        const returnedByPack = new Map<any, any>();
        (result.orderDetailsData || []).forEach(r => returnedByPack.set(r.pgsPackConfigHeaderId, r));
        (this.originalItemList || []).forEach(product => {
          const returned = returnedByPack.get(product.pgsPackConfigHeaderId);
          if (!returned) {
            return;
          }
          product.availableQuantity = returned.availableQuantity;
          product.allocatedQuantity = returned.allocatedQuantity;
          product.active = returned.active;
          product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
          (returned.errors || []).forEach(itemError => {
            product.lineErrors.errors.push({ id: itemError.id, error: itemError.error });
          });
          if (product.lineErrors.errors.length > 0) {
            this.errorMsgs.push(product.lineErrors);
          }
        });
        this.getCommonErrors(this.errorMsgs);
        this.pgsOrderSourceCopy = JSON.parse(JSON.stringify(this.originalItemList));
        this.isPlaceOrderDisable = true;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('The Proving Ground Seed order could not be created. No changes were saved.');
    }));

  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  getFilterData() {
    this.keepFilter();
    //this.applyFilterData(this.productFilters);
  }

  // Keep the selected filter in case of edit
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.PackName && this.productFilters.PackName != '') {
          this.filterValueList.push('Pack Name : ' + this.productFilters.PackName);
        }
        if (this.productFilters.Variety && this.productFilters.Variety != '') {
          this.filterValueList.push('Hybrid Variety : ' + this.productFilters.Variety);
        }
        if (this.productFilters.ItemNumberList && this.productFilters.ItemNumberList.length > 0) {
          this.filterValueList.push('Item Number : ' + this.productFilters.ItemNumberList.join(', '));
        }
      }
    }

  }

  // Clear the selected filters
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
  }

  // Clear single filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
      this.onSearchClick();
      if (this.filterValueList.length < 1) {
        // remove all filter
      }
    }
  }



  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Pack Name':
        this.productFilters.PackName = '';
        break;
      case 'Item Number':
        this.productFilters.ItemNumberList = [];
        break;
      case 'Hybrid Variety':
        this.productFilters.Variety = '';
        break;
      default:
        break;
    }
  }

  // Reset the filters
  resetProductFilter() {
    this.productFilters = {
      PackName: '',
      Variety: '',
      ItemNumberList: []
    };
    this.bindDataSource(this.originalItemList, true);
  }



  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.pgsOrderSource.filter = filterValue;
  }

  quantityTextChange(productItem) {
    if (/^0/.test(productItem.orderQty) && productItem.orderQty != '0') {
      productItem.orderQty = productItem.orderQty.replace(/^0/, '');
    }
    productItem.lastUpdatedTime = new Date();
    this.validateUpdateTotalOrderQuantity(productItem);
  }

  // Plot Seed Order Unit Change and validation
  OrderUnitChange(action: string, productItem: any) {
    // Ensure orderQuantity is a number (handle null/undefined/empty string)
    const currentQty = isNaN(+productItem.orderQuantity) ? 0 : +productItem.orderQuantity;
    var changeQty = 0;
    if (action === 'decrease') {
      changeQty = Math.max(0, currentQty - 1);
    }
    else if (action === 'increase') {
      changeQty = currentQty + 1;
    }

    // Apply max limit if availableQty exists
    if (productItem.availableQuantity != null) {
      productItem.orderQuantity = Math.min(changeQty, productItem.availableQuantity);
    }

    productItem.lastUpdatedTime = new Date();

    this.validateUpdateTotalOrderQuantity(productItem);
    //this.validateLineItem(productItem, 'orderQuantity');
  }

  updateOriginalItemListById(id: number, value: any, type: "orderQuantity" | "errors") {
    const item = this.originalItemList.find(x => x.rowId === id);
    if (!item) return;

    type === "orderQuantity"
      ? (item.orderQuantity = +value)
      : (item.lineErrors.errors = value);
  }


  validateUpdateTotalOrderQuantity(item) {
    this.totalOrderQuantity = 0;
    this.updateOriginalItemListById(item.rowId, +item.orderQuantity, "orderQuantity");
    this.originalItemList.filter(x => +x.orderQuantity > 0).forEach(x => {
      this.totalOrderQuantity += +x.orderQuantity;
    });

    if (!(+item.orderQuantity > 0)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'packInactive');
    }

    if (item.orderQuantity > item.availableQuantity) {
      if (item.orderQuantity > 0) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
        item.lineErrors.errors.push({
          id: 'availableUnits', error: 'Order Quantity cannot be more than Available Quantity'
        });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
      }

      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    else {
      const errorProducts = this.pgsOrderSource.data.filter(
        x => x.lineErrors && x.lineErrors.errors && x.lineErrors.errors.length > 0
      );
      errorProducts.forEach(row => {
        if (+row.orderQuantity > +row.availableQuantity) {
          return;
        }
        row.lineErrors.errors = row.lineErrors.errors.filter(y => y.id != 'availableUnits');
        if (row.lineErrors.errors.length === 0) {
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != row.rowId);
        }
      });
    }

    if (item.lineErrors.errors.length === 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    this.getCommonErrors(this.errorMsgs);
    this.enableDisablePlaceOrder();
    this.updateOriginalItemListById(item.rowId, item.lineErrors.errors, "errors");
    this.IsLinesGreaterThanZeroDisable = this.totalOrderQuantity <= 0;
    if (this.totalOrderQuantity <= 0) {
      this.filterData(false);
      this.pgsOrder.IsLinesGreaterThanZero = false;
    }

    this.pgsOrderSourceCopy = JSON.parse(JSON.stringify(this.originalItemList));
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean, isExistingOrder = false) {
    if (orderList && orderList != null) {
      orderList = this.pgsOrder.IsLinesGreaterThanZero
        ? orderList.filter(x => x.orderQuantity > 0)
        : orderList;

      this.pgsOrderSource = new MatTableDataSource(orderList);

      this.pgsOrderSource.filterPredicate = (data: any, filter: any) => {
        if (data.variety == null || data.variety == 'undefined') {
          data.variety = '';
        }
        if ((filter.Variety == null || data.variety.toLowerCase().indexOf(filter.Variety.toLowerCase()) > -1)) {
          return true;
        }
        else {
          return false;
        }
      };

      // this.applyFilterData(this.productFilters);
      // created deep copy
      if (isClone) {
        this.pgsOrderSourceCopy = JSON.parse(JSON.stringify(orderList));
      }
      if (!isExistingOrder) {
        this.enableDisablePlaceOrder();
      }
    }
  }


  // Hide/show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.pgsOrderSourceCopy.length > 0 && this.pgsOrderSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.pgsOrderSourceCopy.filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.pgsOrderSource.data.findIndex(x => x.rowId == element.rowId);
        // replace current with old object if exist

        let totalQty = 0;
        this.originalItemList.filter(x => x.rowId !== element.rowId && x.orderQuantity > 0).forEach(x => {
          totalQty += +x.orderQuantity;
        });
        const isPackInactive = (element.lineErrors?.errors || []).some(e => e.id == 'packInactive');
        const rowAvailableQty = isPackInactive ? 0 : +element.availableQuantity;
        let qty = rowAvailableQty > 0 ? rowAvailableQty : 0;

        if (oldLineValue) {
          oldLineValue.orderQuantity = +qty;
          oldLineValue.lineErrors.errors = [];
        }
        this.totalOrderQuantity = totalQty + +qty;
        const index = this.originalItemList.findIndex(x => x.rowId === element.rowId);
        if (index != -1) {
          this.originalItemList[index].lineErrors.errors = [];
          this.originalItemList[index].orderQuantity = +qty;
        }

        this.IsLinesGreaterThanZeroDisable = this.totalOrderQuantity <= 0;


        if (currentLineIndex != -1 && index != -1) {
          this.pgsOrderSource.data[currentLineIndex] = this.originalItemList[index];
        }

        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != element.rowId);
        this.bindDataSource(this.pgsOrderSource.data, false);
        // to hide one error after revert changes
        this.showHideLineError(element.rowId);
        if (this.totalOrderQuantity <= 0) {
          this.filterData(false);
          this.pgsOrder.IsLinesGreaterThanZero = false;
        }
        this.index = 0;
        this.currentErrorRow = 1;
        this.pgsOrderSourceCopy = JSON.parse(JSON.stringify(this.originalItemList));
      }
      else {
        // To hide all errors after revert all changes

        this.originalItemList.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            const index = this.pgsOrderSource.data.findIndex(y => y.rowId == x.rowId);
            const oldLineValue = this.pgsOrderSourceCopy.filter(y => y.rowId == x.rowId)[0];
            let totalQty = 0;
            this.originalItemList.filter(y => y.rowId !== x.rowId && y.orderQuantity > 0).forEach(z => {
              totalQty += +z.orderQuantity;
            });
            const isPackInactive = (x.lineErrors?.errors || []).some(e => e.id == 'packInactive');
            const rowAvailableQty = isPackInactive ? 0 : +x.availableQuantity;
            let qty = rowAvailableQty > 0 ? rowAvailableQty : 0;
            this.totalOrderQuantity = totalQty + +qty;

            if (oldLineValue) {
              oldLineValue.orderQuantity = +qty;
              oldLineValue.lineErrors.errors = [];
            }
            x.orderQuantity = +qty;
            if (index != -1) {
              this.pgsOrderSource.data[index].orderQuantity = +qty;
              this.pgsOrderSource.data[index].lineErrors.errors = [];
            }
            x.lineErrors.errors = [];
            this.showHideLineError(x.rowId);
          }
        });

        this.totalOrderQuantity = this.originalItemList
          .filter(y => +y.orderQuantity > 0)
          .reduce((sum, y) => sum + +y.orderQuantity, 0);
        this.IsLinesGreaterThanZeroDisable = this.totalOrderQuantity <= 0;
        // To hide common error msg
        this.errorMsgs = new Array();
        this.bindDataSource(this.pgsOrderSource.data, false);
        if (this.totalOrderQuantity <= 0) {
          this.filterData(false);
          this.pgsOrder.IsLinesGreaterThanZero = false;
        }
        this.pgsOrderSourceCopy = JSON.parse(JSON.stringify(this.originalItemList));
      }
    }
  }


  filterData(getZeroQtyRecordsChecked: boolean) {
    this.pgsOrder.IsLinesGreaterThanZero = getZeroQtyRecordsChecked;
    this.applyAllFilters(true);
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
      $('#orderView').animate({ scrollTop: nextOffset }, 1000);
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.index = 0;
    this.currentErrorRow = 1;
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }

  openPackDetails(element: any) {
    if (!element) {
      return;
    }

    this.selectedPackName = element.packName || '';
    this.selectedPackDetails = element.pgsPackConfigHeaderId && element.packConfigDetails
      ? element.packConfigDetails
      : [];
    this.showPackModal = true;
  }

  closePackModal() {
    this.showPackModal = false;
    this.selectedPackName = '';
    this.selectedPackDetails = [];
  }

  // Go to landing seed fulfillment page
  navigateToLanding() {
    if (this.readOnlyAccess) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
    }
    this.router.navigate(['/proving-ground-seed-landing']);
  }

  ngOnDestroy() {
    this.pgsOrderService.setPgsOrderHeaderId(0);
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
// Class model for Release
export class PgsOrder {
  SalesManagerAccount: number;
  OrderNumber: string;
  OrderHeaderId: number;
  ShipToAccount: number;
  DeliverToAccount: number;
  DeliverToAnotherLocation: boolean;
  IsCustomerPickup: boolean;
  IsLinesGreaterThanZero: boolean;
  DeliveryInstructionsCodes: string;
  CustomerPO: string;
  ProductLine: string;
  CompanyCode: string;
  OrderItemsList: Array<PgsOrderItems> = [];
}


export class PgsOrderItems {
  OrderHeaderId: number;
  OrderDetailId: number;
  PgsPackConfigHeaderId: string;
  PackName: string;
  OrderQty: number;
  AllocatedQuantity: number;
  AvailableQuantity: number;
}

